import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { AuthErrorScreen } from '../features/auth/screens/AuthErrorScreen';
import { SplashScreen } from '../features/auth/screens/SplashScreen';
import { I18nProvider } from '../i18n/provider';
import { AppShell } from './AppShell';
import { AuthProvider } from './providers/AuthProvider';
import { useAuth } from './providers/useAuth';

const queryClient = new QueryClient();

// PARA-105 §6 — рендерит Splash/AuthError до готовности AuthProvider,
// AppShell — после успешной аутентификации.
function AuthGate(): JSX.Element {
  const { status } = useAuth();
  if (status === 'loading') {
    return <SplashScreen />;
  }
  if (status === 'error') {
    return <AuthErrorScreen />;
  }
  return <AppShell />;
}

// PARA-105 §6 — точка входа: QueryClientProvider → I18nextProvider →
// AuthProvider → AppShell.
export function App(): JSX.Element {
  return (
    <QueryClientProvider client={queryClient}>
      <I18nProvider>
        <AuthProvider>
          <AuthGate />
        </AuthProvider>
      </I18nProvider>
    </QueryClientProvider>
  );
}
